<template>
  <div class="animated fadeIn">
    <h4 class="page-title">User Roles</h4>
    <hr />
    <div class="row">
      <div class="col">
        <div style="margin: 0 auto; width: 10px;" v-if="isFetching">
          <div class="loader-dark-blue medium mb-5 mt-5"></div>
        </div>
        <div class="mb-5" v-show="!isFetching">
          <span v-show="roles.length" class="float-left">Number of data found: <b-badge pill variant="primary">{{roles.length}}</b-badge></span>
          <b-btn class="float-right" variant="primary" size="sm" @click="add()" v-show="!isFetching"><i class="fa fa-plus"></i> Add</b-btn>
        </div>
        <b-alert variant="danger"
          class="text-center"
          :show="!isFetching && !roles.length">
          Data is empty
        </b-alert>
        <b-table responsive hover striped :fields="fields" :items="roles" :per-page="itemsPerPage" :current-page="currentPage" v-show="roles.length">
          <template v-slot:cell(STATUS)="row">
            <span class="badge badge-sm" v-bind:class="{'badge-success': row.value, 'badge-danger': !row.value}">{{row.value ? 'ACTIVE' : 'INACTIVE'}}</span>
          </template>
          <template v-slot:cell(ACTIONS)="row">
            <b-btn variant="warning" size="sm" @click="edit(row.item)" v-b-tooltip.hover title="Edit role">
              <i class="fa fa-pencil-square-o"></i>
            </b-btn>
          </template>
        </b-table>
        <b-pagination v-show="roles.length > 10" :total-rows="roles.length" :per-page="itemsPerPage" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>
<script>
import { server, fieldsService } from '@/services/'
import { UserRolesModal } from '@/components/modals/'
import { mapState } from 'vuex'

export default {
  name: 'user-roles',
  data () {
    return {
      errorMsg: Object,
      itemsPerPage: 10,
      currentPage: 1,
      itemsCount: 0,
      fields: fieldsService.USER_ROLES
    }
  },
  methods: {
    add () {
      this.$modal.show(UserRolesModal, {mode: 'Add'}, {height: 'auto'});
    },
    edit (obj) {
      this.$modal.show(UserRolesModal, {mode: 'Edit', model: obj}, {height: 'auto'});
    }
  },
  computed: {
    ...mapState('userRole', {
      roles: state => state.items,
      isFetching: state => state.isFetching
    })
  },
  created () {
    this.$store.commit('userRole/setIsFetching', true)
    this.$store.cache.dispatch('userRole/getAll').then(
      resp => {
        this.$store.commit('userRole/setIsFetching', false)
      }
    )
  }
}
</script>
